(function(){
  if(window.__hmCardCartBound)return;
  window.__hmCardCartBound=true;

  if(!document.getElementById('hm-kiddo-upsell-mobile-style')){
    var style=document.createElement('style');
    style.id='hm-kiddo-upsell-mobile-style';
    style.textContent='@media(max-width:749px){.hmkp__related-card--buy{grid-template-columns:150px 1fr!important}.hmkp__related-card--buy .hmc__img{width:100%!important;min-width:0!important;max-width:none!important}}.hmc__add.is-loading{cursor:default!important}.hm-kiddo-card__add.is-loading{cursor:default!important}';
    document.head.appendChild(style);
  }

  function findForm(el){
    return el&&el.closest?el.closest('[data-hmc-form], .hmc__form'):null;
  }

  function getId(form){
    var hidden=form.querySelector('input[data-hmc-vid]');
    if(hidden&&hidden.value)return hidden.value;
    var radio=form.querySelector('input[data-hmc-variant]:checked');
    if(radio&&radio.value)return radio.value;
    var select=form.querySelector('select[data-hmc-vid]');
    if(select&&select.value)return select.value;
    var idInput=form.querySelector('select[name="id"], input[name="id"]');
    return idInput&&idInput.value?idInput.value:'';
  }

  function status(form,msg){
    var out=form.querySelector('[data-hmc-err]');
    if(out)out.textContent=msg||'';
  }

  function setBusy(form,busy,done){
    var btn=form.querySelector('[data-hmc-add]');
    if(!btn)return;
    if(!btn.dataset.hmcOriginal)btn.dataset.hmcOriginal=btn.textContent.trim();
    btn.classList.toggle('is-loading',!!busy);
    btn.setAttribute('aria-busy',busy?'true':'false');
    btn.disabled=!!busy;
    if(busy){btn.textContent='adding...';return;}
    if(done){
      btn.textContent='added';
      setTimeout(function(){
        var sizeSelect=form.querySelector('select[name="id"]');
        btn.textContent=btn.dataset.hmcOriginal;
        btn.disabled=!!(sizeSelect&&!sizeSelect.value);
        btn.removeAttribute('aria-busy');
      },1000);
      return;
    }
    btn.textContent=btn.dataset.hmcOriginal;
    var sizeSelect=form.querySelector('select[name="id"]');
    btn.disabled=!!(sizeSelect&&!sizeSelect.value);
    btn.removeAttribute('aria-busy');
  }

  function cartAddUrl(){
    if(window.theme&&theme.routes&&theme.routes.cart_add_url)return theme.routes.cart_add_url;
    return '/cart/add.js';
  }

  function add(form){
    if(!form||form.dataset.hmcBusy==='1')return;
    var id=getId(form);
    if(!id){status(form,'choose an option first.');return;}

    form.dataset.hmcBusy='1';
    status(form,'');
    setBusy(form,true,false);

    var cart=document.querySelector('mini-cart');
    var fd=new FormData(form);
    fd.set('id',id);
    if(!fd.get('quantity'))fd.set('quantity','1');

    if(cart&&typeof cart.getSectionsToRender==='function'){
      fd.set('sections',cart.getSectionsToRender().map(function(section){return section.id;}).join(','));
      fd.set('sections_url',window.location.pathname);
      if(typeof cart.setActiveElement==='function')cart.setActiveElement(document.activeElement);
    }

    fetch(cartAddUrl(),{
      method:'POST',
      body:fd,
      credentials:'same-origin',
      headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}
    })
      .then(function(r){
        return r.json().then(function(data){
          if(!r.ok||data.status)throw new Error(data.description||data.message||'could not add to cart.');
          return data;
        });
      })
      .then(function(data){
        if(cart&&typeof cart.renderContents==='function'&&data.sections)cart.renderContents(data);
        return data;
      })
      .then(function(){
        form.dataset.hmcBusy='0';
        setBusy(form,false,true);
      })
      .catch(function(err){
        form.dataset.hmcBusy='0';
        status(form,err&&err.message?err.message:'could not add to cart.');
        setBusy(form,false,false);
      });
  }

  document.addEventListener('submit',function(e){
    var form=findForm(e.target);
    if(!form)return;
    e.preventDefault();
    add(form);
  });

  document.addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest('[data-hmc-add]');
    if(!btn)return;
    var form=findForm(btn);
    if(!form)return;
    if((btn.getAttribute('type')||'submit').toLowerCase()==='submit')return;
    e.preventDefault();
    add(form);
  });
})();

(function(){
  if(!document.getElementById('hm-kiddo-shop-all-style')){
    var style=document.createElement('style');
    style.id='hm-kiddo-shop-all-style';
    style.textContent='.hmkp__shop-all-button{display:inline-flex;align-items:center;justify-content:center;min-height:48px;padding:12px 26px;margin-left:12px;border:2px solid #FF8257;border-radius:999px;background:#FFFDF7;color:#FF8257;text-decoration:none;font-family:var(--font-body-family,\'DM Sans\',sans-serif);font-size:14px;font-weight:800}.hmkp__shop-all-button:hover{background:#3A2C31;border-color:#3A2C31;color:#F2F4D4}@media(max-width:749px){.hmkp__shop-all-button{width:100%;max-width:360px;margin:12px auto 0}}';
    document.head.appendChild(style);
  }

  function addKiddoShopAll(){
    document.querySelectorAll('[data-hmkp-back-buy]').forEach(function(section){
      if(section.querySelector('.hmkp__shop-all-button'))return;
      var primary=section.querySelector('.hmkp__back-buy-button');
      if(!primary)return;
      var link=document.createElement('a');
      link.className='hmkp__shop-all-button';
      link.href='/collections/kiddo';
      link.textContent='shop all kiddo';
      primary.insertAdjacentElement('afterend',link);
    });
  }

  addKiddoShopAll();
  document.addEventListener('DOMContentLoaded',addKiddoShopAll,{once:true});
  window.addEventListener('load',addKiddoShopAll,{once:true});
  var observer=new MutationObserver(addKiddoShopAll);
  observer.observe(document.body,{childList:true,subtree:true});
  setTimeout(function(){observer.disconnect();},10000);
})();